import { memoize } from "lodash";

export const getRelativePath = memoize((path: string) =>
  path.replace(/^blocks\./, ""),
);

export const getParentArrayPath = memoize((path: string) =>
  path.replace(/\.\d+$/, ""),
);

export const batchUpdates = (updates: Array<() => void>) => {
  requestAnimationFrame(() => {
    updates.forEach(update => update());
  });
};
